// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBiCopay {
    'appliesToOop'?: string;
    'copay'?: string;
    'notes'?: string;
    'waivedAfterOop'?: boolean;
    'alwaysApplies'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBiCopay>> = [
        {
            "name":     "appliesToOop",
            "baseName": "appliesToOop",
            "type":     "string"
        },
        {
            "name":     "copay",
            "baseName": "copay",
            "type":     "string"
        },
        {
            "name":     "notes",
            "baseName": "notes",
            "type":     "string"
        },
        {
            "name":     "waivedAfterOop",
            "baseName": "waivedAfterOop",
            "type":     "boolean"
        },
        {
            "name":     "alwaysApplies",
            "baseName": "alwaysApplies",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBiCopay.attributeTypeMap;
    }
}
